
import { Options, Vue } from "vue-class-component";
import { BagOrSttDetail } from "@/domain/entities/CargoV2";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import { nextTick } from "vue";

@Options({
  name: "ScanTableList",
  props: {
    items: {
      type: Array as () => BagOrSttDetail[],
      default: () => []
    }
  },
  emits: ["delete"]
})
class ScanTableList extends Vue {
  items!: BagOrSttDetail[];
  get form() {
    return CargoV2Controller.form;
  }

  get columns() {
    return [
      {
        name: this.$t("cargoV2.components.scanTableList.column.no"),
        styleHead: "w-10 text-center whitespace-no-wrap",
        styleCustom: "align-center",
        render: (_: any, index: number) => {
          return `<div class="text-black-lp-300">${index + 1}</div>`;
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.bagNo"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: BagOrSttDetail) => {
          return `<div class="text-black-lp-300 whitespace-no-wrap font-medium">
                  ${item.bagNo || "-"}
                </div>`;
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.chargeableBag"),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: BagOrSttDetail) => {
          const weight =
            item.bagChargeableWeight ||
            item.bagData?.bagTotalChargeableWeight ||
            0;
          return `<div class="text-black-lp-300 whitespace-no-wrap">
              ${weight ? `${weight} kg` : "-"}
            </div>`;
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.sttNo"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        slotName: "stt_no",
        "custom-slot": true
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.chargeableStt"),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: BagOrSttDetail) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const detail of item.sttDetails) {
              html += `<div class="text-black-lp-300">${
                detail.chargeableWeight ? `${detail.chargeableWeight} kg` : "-"
              }</div>`;
            }
            html += `</div>`;
            return html;
          }
          return "";
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.shippingType"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: BagOrSttDetail) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const detail of item.sttDetails) {
              html += `<div><span class="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-semibold">${detail.productType ||
                "-"}</span></div>`;
            }
            html += `</div>`;
            return html;
          }
          return "";
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.commodity"),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: BagOrSttDetail) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const detail of item.sttDetails) {
              html += `<div class="text-black-lp-300 whitespace-nowrap">${this.elipsisText(
                detail.commodityName || "-"
              )}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return "";
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.destinationCity"),
        styleHead: "w-32 text-center whitespace-no-wrap",
        styleCustom: "text-center",
        render: (item: BagOrSttDetail) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const detail of item.sttDetails) {
              html += `<div><span class="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-semibold">${detail.destinationCityCode ||
                "-"}</span></div>`;
            }
            html += `</div>`;
            return html;
          }
          return "";
        }
      },
      {
        name: this.$t("cargoV2.components.scanTableList.column.action"),
        key: "actionable_column",
        styleHead: "w-36 text-center whitespace-no-wrap",
        showButton: () => true
      }
    ];
  }

  get customButton() {
    return {
      outline: true,
      iconV2: true,
      iconLeft: "delete",
      sizeIcon: "w-4",
      iconGroupHoverColor: CargoV2Controller.isLoadingCalculateVolume
        ? "text-gray-lp-600"
        : "text-red-lp-100",
      title: this.$t("cargoV2.components.scanTableList.delete"),
      textColor: "red-lp-100",
      color: "red-lp-100",
      small: false,
      customClass: "whitespace-no-wrap",
      disabled: CargoV2Controller.isLoadingCalculateVolume,
      clickFunction: (item: BagOrSttDetail) => {
        // Emit the full item object (which might contain sttDetails for bags)
        // The parent component is responsible for finding and removing these items from the source list
        this.$emit("delete", item);
      }
    };
  }

  elipsisText(val: string) {
    return ellipsisString(val, 13);
  }
}
export default ScanTableList;
